import type { RttsButtonState, RttsGateFields, RttsUserRole } from '../types';

/**
 * Pure two-gate state machine for the Run The Tape button.
 * Keep branching here — components only render the returned state.
 *
 * Re-run / regenerate is intentionally not a state: when a reel exists the
 * surface is watch-only (inline player). Initial generate remains for
 * broadcasters with no reel.
 */
export function deriveButtonState(
  gates: Pick<RttsGateFields, 'rtts_entitled' | 'can_generate' | 'existing_reel'>,
  userRole: RttsUserRole
): RttsButtonState {
  const hasReel = Boolean(gates.existing_reel);

  if (!gates.rtts_entitled) {
    return userRole === 'commissioner' ? 'UPGRADE' : 'MEMBER_LOCKED';
  }

  if (hasReel) {
    return 'WATCH';
  }

  if (gates.can_generate) {
    return 'GENERATE';
  }

  return 'PASSIVE_HINT';
}
